import React, { FC }        from 'react';

interface Props {
	caveat: string,
	whatMightChange: string,
}

const defaultProps: Props = {
	caveat:          'This value is an estimate.',
	whatMightChange: 'this value',
}

const CaveatMessage: FC<Props> = ( props ) => {
	
	return (
		<>{ props.caveat } The details, activities, and timeline of your specific project may change { props.whatMightChange }.</>
	);
};

CaveatMessage.defaultProps = defaultProps;

export { CaveatMessage }
